/* eslint-disable max-classes-per-file */
import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines a free text answer corresponding to a free text question.
 */
export class NotEvaluatedQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of a free text answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.answer = bo.answer;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new NotEvaluatedQuestionAnswerModel(bo);
  }
}
